import { createContext, useContext } from 'react';
import { UserType } from '@context/UserContext';
import api from '@services/api';
import { logout } from '@services/auth/Auth';
import { Address } from '@global.types';

export interface CompanyType {
  id: string;
  corporateName: string;
  isDefault: boolean;
  cnpj: string;
  address: Partial<Address>;
  email: string | null;
  hasElectronicInvoiceIssuance?: boolean;
  nomeFantasia?: string;
  razaoSocial?: string;
  municipalInscription?: string;
  stateInscription?: string;
}

export interface CompaniesContextTypes {
  companies: CompanyType[];
  setSelectedCompany: (currentCompany?: CompanyType) => void;
  selectedCompany?: CompanyType;
}

const COMPANY_CONTEXT_DEFAULT_VALUE = {
  companies: [],
  setSelectedCompany: () => {},
  selectedCompany: undefined,
};

export const CompaniesContext = createContext<CompaniesContextTypes>(COMPANY_CONTEXT_DEFAULT_VALUE);

export const useCompaniesContext = () => useContext(CompaniesContext);

type State<T> = { errorCompany: string; companiesData: CompanyType[] };

export function getCompanies<T>(authData: UserType): State<T> {
  return api()
    .get(`admin/empresas/get-own-companies?userId=${authData.sub}`)
    .then(({ data }) => ({ errorCompany: undefined, companiesData: data }))
    .catch(async error => {
      await logout();
      return { errorCompany: error.toString(), companiesData: undefined };
    });
}
